import { useState } from "react";
import { Box, Button, Center, Heading, Stack, Text } from "@chakra-ui/react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/auth/AuthProvider";

// Authenticated Firebase user without an admins/{uid} record.
export const NoAccessPage = () => {
  const { firebaseUser, status, logout } = useAuth();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  if (status === "anon") {
    return <Navigate to="/publishers/panel/login" replace />;
  }

  if (status === "admin") {
    return <Navigate to="/publishers/panel" replace />;
  }

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/publishers/panel/login", { replace: true });
    } catch {
      setIsLoggingOut(false);
    }
  };

  return (
    <Center minH="100vh" px={4} bg="gray.50">
      <Box bg="white" p={10} borderRadius="2xl" boxShadow="md" maxW="440px" textAlign="center">
        <Stack spacing={5}>
          <Heading size="md" color="brand.charcoal">
            Немає доступу
          </Heading>
          <Text color="gray.500" fontSize="sm">
            Акаунт {firebaseUser?.email} не має прав видавця. Зверніться до
            адміністратора, якщо вважаєте, що це помилка.
          </Text>
          <Button
            variant="outline"
            colorScheme="orange"
            isLoading={isLoggingOut}
            onClick={handleLogout}
          >
            Вийти
          </Button>
        </Stack>
      </Box>
    </Center>
  );
};
